import { render, staticRenderFns } from "./InterfaceEdit.vue?vue&type=template&id=1e0237b2&"
import script from "./InterfaceEdit.vue?vue&type=script&lang=js&"
export * from "./InterfaceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e0237b2')) {
      api.createRecord('1e0237b2', component.options)
    } else {
      api.reload('1e0237b2', component.options)
    }
    module.hot.accept("./InterfaceEdit.vue?vue&type=template&id=1e0237b2&", function () {
      api.rerender('1e0237b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Resource/InterfaceEdit.vue"
export default component.exports